


<div class="container mt-4" style="min-height: calc(100vh - 300px);">
    <div class="row">
        <div class="col-lg-12">
    <div class="card">
        <div class=" card-header">
            <h5 class="font-medium election-title">📄 Planning and development</h5>
        </div>
        <div class="card-body">
            <div class="row">
                <form [formGroup]="targetForm" (ngSubmit)="getProgressDetail()">
                    <div class="row align-items-end">
                        <div class="col-lg-4 col-md-6 mb-2" *ngIf="this.UserDetails?.roleId == 1">
                            <label class="form-label">Circle Office <span class="text-danger">*</span></label>
                            <select class="form-control" formControlName="circleOffice" (change)="GetBlock()">
                                <option value="">--Select--</option>
                                <option *ngFor="let circle of circlesList" [value]="circle?.iCircleId">
                                    {{ circle?.sCircleName }}
                                </option>
                            </select>
                            <div *ngIf="targetForm.get('circleOffice')?.touched && targetForm.get('circleOffice')?.invalid"
                                class="text-danger small">
                                Circle office is required
                            </div>
                        </div>
                        <!-- Block Office -->
                        <div class="col-lg-4 col-md-6 mb-2">
                            <label class="form-label">Block Office <span class="text-danger">*</span></label>
                            <select class="form-control" formControlName="blockOffice">
                                <option value="" selected>--Select--</option>
                                <option *ngFor="let block of blockList" [value]="block?.iBlockId">
                                    {{ block?.sBlockName }}
                                </option>
                            </select>
                            <div *ngIf="targetForm.get('blockOffice')?.touched && targetForm.get('blockOffice')?.invalid"
                                class="text-danger small">
                                block Office is required
                            </div>
                        </div>

                        <!-- Financial Year -->
                        <div class="col-lg-4 col-md-6 mb-2">
                            <label class="form-label">Financial/Reporting Year <span
                                    class="text-danger">*</span></label>
                            <select class="form-control" formControlName="financialYear">
                                <option value="">--Select--</option>
                                <option *ngFor="let years of financialYears" [ngValue]="years?.financialYear">
                                    {{ years?.financialYear }}
                                </option>
                            </select>
                            <div *ngIf="targetForm.get('financialYear')?.touched && targetForm.get('financialYear')?.invalid"
                                class="text-danger small">
                                Financial year is required
                            </div>
                        </div>

                        <!-- Submit -->
                        <div class="col-lg-12 text-end">
                            <button type="submit" class="btn btn-primary" [disabled]="targetForm.invalid">
                                Get Report
                            </button>
                        </div>

                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
        <div class="col-lg-12">
            <div class="card">
                <!-- <div class="card-header">
          <h5 class="m-0 font-medium">📄 Progress and Development</h5>
        </div> -->
                <div class=" card-header">
                    <div class="d-flex align-items-center justify-content-between">
                        <h5 class="font-medium m-0">📄Report</h5>
                        <button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal"
                            (click)="goToTarget()"
                            *ngIf="showButton && (this.UserDetails?.roleId ==11 || this.UserDetails?.roleId ==13)">+ Add
                            Progress {{currentMonth?.name}}</button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th>S.No.</th>
                                    <th>Month</th>
                                    <th>Coop. Society</th>
                                    <th>Type of Coop. Society</th>
                                    <th>Outstanding Govt. Investment up to</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let item of progressData; let i = index">
                                    <td>{{ i + 1 }}</td>
                                    <td>{{ getMonthName(item.dataMonth) }}</td>
                                    <td>{{ item.sSocietyName }}</td>
                                    <td>{{ item.coopSocietiesType }}</td>
                                    <td>{{ item.govtInvestment | number }}</td>
                                    <td>
                                        <div class="d-flex align-items-center gap-1">

                                            <!-- Always show View Report button -->
                                            <button type="button" class="btn btn-primary btn-sm" title="View Report"
                                                (click)="viewReport(item)">
                                                <i class="bi bi-eye-fill"></i>
                                            </button>

                                            <!-- Show Edit / Verify / Delete buttons only when not verified -->
                                            <ng-container *ngIf="!item.isVerified && this.UserDetails?.roleId !== 1">

                                                <!-- Edit Button -->
                                                <button type="button" class="btn btn-primary btn-sm"
                                                    title="Click to Edit" (click)="editRow(item)">
                                                    <i class="bi bi-pencil-square"></i>
                                                </button>

                                                <!-- Verify Button -->
                                                <button type="button" class="btn btn-success btn-sm"
                                                    title="Click to Verify" *ngIf="this.UserDetails?.roleId == 13"
                                                    data-bs-toggle="modal" data-bs-target="#verifyConfirmModal"
                                                    (click)="setDeleteIndex(item?.id)">
                                                    <i class="bi bi-clipboard2-check"></i>
                                                </button>

                                                <!-- Delete Button -->
                                                <button type="button" class="btn btn-danger btn-sm"
                                                    title="Click to Delete" data-bs-toggle="modal"
                                                    data-bs-target="#deleteConfirmModal"
                                                    (click)="setDeleteIndex(item?.id)">
                                                    <i class="bi bi-trash3"></i>
                                                </button>

                                            </ng-container>

                                        </div>


                                        <!-- <div class="d-flex align-items-center gap-1">
                                            <ng-container
                                            
                                                *ngIf="!item.isVerified && this.UserDetails?.roleId !==1; else verifiedBlock">
                                                <button type="button" class="btn btn-primary btn-sm" title="View Report"
                                                (click)="viewReport(item)">
                                                <i class="bi bi-eye-fill"></i>
                                            </button>
                                                <button type="button" class="btn btn-primary btn-sm"
                                                    title="Click to Edit" (click)="editRow(item)">
                                                    <i class="bi bi-pencil-square"></i>
                                                </button>
                                                <button type="button" class="btn btn-success btn-sm"
                                                    title="Click to Verify" *ngIf="this.UserDetails?.roleId ==13"
                                                    data-bs-toggle="modal" data-bs-target="#verifyConfirmModal"
                                                    (click)="setDeleteIndex(item?.id)">
                                                    <i class="bi bi-clipboard2-check"></i>
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm"
                                                    title="Click to Delete" data-bs-toggle="modal"
                                                    data-bs-target="#deleteConfirmModal"
                                                    (click)="setDeleteIndex(item?.id)">
                                                    <i class="bi bi-trash3"></i>
                                                </button>
                                            </ng-container>

                                           
                                            <ng-template #verifiedBlock>
                                                <button type="button" class="btn btn-primary btn-sm">
                                                    <i class="bi bi-lock"></i>
                                                </button>
                                            </ng-template>
                                        </div> -->
                                    </td>

                                    <!-- <td>
                                        <div class="d-flex align-items-center gap-2">
                                            <button type="button" class="btn btn-primary btn-sm"
                                                    title="Click to Edit" (click)="editRow(item)">
                                                    <i class="bi bi-pencil-square"></i>
                                                </button>
                                            <button type="button" class="btn btn-primary btn-sm" title="View Report"
                                                (click)="viewReport(item)">
                                                <i class="bi bi-eye-fill"></i>
                                            </button>

                                            <button type="button" class="btn btn-warning btn-sm" title="Verify Report"
                                                (click)="verifyReport(item)">
                                                <i class="bi bi-clipboard2-check"></i>
                                            </button>

                                            <button type="button" class="btn btn-danger btn-sm" title="Delete Report"
                                                (click)="deleteReport(item.id)">
                                                <i class="bi bi-trash3"></i>
                                            </button>
                                        </div>
                                    </td> -->
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>






<!-- Delete Confirmation Modal -->
<div class="modal fade" id="deleteConfirmModal" tabindex="-1" aria-labelledby="deleteConfirmModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Delete</h5>
                <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
            </div>
            <div class="modal-body">
                Are you sure you want to delete ?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                    (click)="cancelDelete()">Cancel</button>
                <button type="button" class="btn btn-danger" data-bs-dismiss="modal" aria-label="Close"
                    (click)="deleteAuditConducted(deleteIndex)">Delete</button>
            </div>
        </div>
    </div>
</div>

<!-- verify Confirmation Modal -->
<div class="modal fade" id="verifyConfirmModal" tabindex="-1" aria-labelledby="verifyConfirmModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Veriication</h5>
                <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
            </div>
            <div class="modal-body">
                Are you sure you want to Verify?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                    (click)="this.deleteIndex = 0;">Cancel</button>
                <button type="button" class="btn btn-success" data-bs-dismiss="modal" aria-label="Close"
                    (click)="verifyAuditConducted(deleteIndex)">Verify</button>
            </div>
        </div>
    </div>
</div>